import React from 'react';
import { Grid, Card, CardContent, Typography, Container, useMediaQuery, useTheme } from '@mui/material';
import { FaHtml5, FaCss3Alt, FaReact, FaJs, FaPython, FaJava, FaDatabase, FaNodeJs, FaCloud, FaCode, FaCogs, FaDocker, FaGitAlt, FaRobot, FaBrain, FaLink, FaTerminal, FaMagic, FaWrench } from 'react-icons/fa';
import { DiMaterializecss } from 'react-icons/di';
import { SiMongodb, SiNetapp, SiCplusplus, SiLinux, SiAmazonaws, SiKubernetes, SiTerraform, SiSwagger, SiJenkins, SiFastapi, SiExpress, SiPostgresql, SiRedis, SiTypescript, SiGithubactions, SiOpenai, SiPytest, SiJest, SiRender } from 'react-icons/si';

const skills = [
    { name: 'Claude API', icon: <FaRobot color="#D97757" size="3em" /> },
    { name: 'OpenAI API', icon: <SiOpenai color="#412991" size="3em" /> },
    { name: 'Groq (Llama 3.3)', icon: <FaBrain color="#F55036" size="3em" /> },
    { name: 'LangChain', icon: <FaLink color="#1C3C3C" size="3em" /> },
    { name: 'RAG', icon: <FaCode color="#6B46C1" size="3em" /> },
    { name: 'AI Agents', icon: <FaRobot color="#f9004d" size="3em" /> },
    { name: 'Tool Use', icon: <FaWrench color="#3B82F6" size="3em" /> },
    { name: 'Prompt Engineering', icon: <FaMagic color="#10B981" size="3em" /> },
    { name: 'Cursor', icon: <FaTerminal color="#000000" size="3em" /> },
    { name: 'Python', icon: <FaPython color="#3776AB" size="3em" /> },
    { name: 'Java', icon: <FaJava color="#007396" size="3em" /> },
    { name: 'JavaScript', icon: <FaJs color="#F7DF1E" size="3em" /> },
    { name: 'TypeScript', icon: <SiTypescript color="#3178C6" size="3em" /> },
    { name: 'C++', icon: <SiCplusplus color="#00599C" size="3em" /> },
    { name: 'Node.js', icon: <FaNodeJs color="#339933" size="3em" /> },
    { name: 'Express.js', icon: <SiExpress color="#000000" size="3em" /> },
    { name: 'FastAPI', icon: <SiFastapi color="#009688" size="3em" /> },
    { name: 'REST APIs', icon: <FaCogs color="#FF5733" size="3em" /> },
    { name: 'React', icon: <FaReact color="#61DAFB" size="3em" /> },
    { name: 'HTML', icon: <FaHtml5 color="#E34F26" size="3em" /> },
    { name: 'CSS', icon: <FaCss3Alt color="#1572B6" size="3em" /> },
    { name: 'Material-UI', icon: <DiMaterializecss color="#0081CB" size="3em" /> },
    { name: 'PostgreSQL', icon: <SiPostgresql color="#336791" size="3em" /> },
    { name: 'MySQL', icon: <FaDatabase color="#4479A1" size="3em" /> },
    { name: 'MongoDB', icon: <SiMongodb color="#47A248" size="3em" /> },
    { name: 'Redis', icon: <SiRedis color="#DC382D" size="3em" /> },
    { name: 'AWS', icon: <SiAmazonaws color="#FF9900" size="3em" /> },
    { name: 'Docker', icon: <FaDocker color="#2496ED" size="3em" /> },
    { name: 'Kubernetes', icon: <SiKubernetes color="#326CE5" size="3em" /> },
    { name: 'Terraform', icon: <SiTerraform color="#5C4EE5" size="3em" /> },
    { name: 'Jenkins', icon: <SiJenkins color="#D24939" size="3em" /> },
    { name: 'GitHub Actions', icon: <SiGithubactions color="#2088FF" size="3em" /> },
    { name: 'Render', icon: <SiRender color="#46E3B7" size="3em" /> },
    { name: 'Linux', icon: <SiLinux color="#FCC624" size="3em" /> },
    { name: 'CI/CD', icon: <FaCogs color="#808080" size="3em" /> },
    { name: 'Git', icon: <FaGitAlt color="#F05032" size="3em" /> },
    { name: 'Pytest', icon: <SiPytest color="#0A9EDC" size="3em" /> },
    { name: 'Jest', icon: <SiJest color="#C21325" size="3em" /> },
    { name: 'Postman', icon: <FaCode color="#FF6C37" size="3em" /> },
    { name: 'Swagger', icon: <SiSwagger color="#85EA2D" size="3em" /> },
    { name: 'Full-Stack Development', icon: <FaCode color="#00ADEF" size="3em" /> },
    { name: 'Cloud Computing', icon: <FaCloud color="#00ADEF" size="3em" /> },
    { name: 'Data Structures', icon: <FaDatabase color="#FF5733" size="3em" /> },
    { name: 'OOP', icon: <FaCogs color="#FF5733" size="3em" /> },
    { name: 'NetApp ASE', icon: <SiNetapp color="#0052CC" size="3em" /> },
];

const Skills = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Container>
      <Typography
        variant="h4"
        component="div"
        gutterBottom
        sx={{
          fontWeight: 'bold',
          textAlign: 'center',
          fontSize: isMobile ? '30px' : '40px',
          color: 'black',
          marginBottom: '3%',
        }}
      >
        <span style={{ color: '#f9004d' }}>My</span> Skills
      </Typography>
      <Grid container spacing={3} justifyContent="center">
        {skills.map((skill) => (
          <Grid item key={skill.name} xs={5} sm={6} md={4} lg={3}>
            <Card sx={{
              display: 'flex',
              flexDirection: 'column',
              transition: 'transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out',
              '&:hover': {
                transform: 'scale(1.05)',
                boxShadow: '0 4px 20px rgba(0,0,0,0.2)'
              }
            }}>
              <CardContent style={{ textAlign: 'center' }}>
                <Typography variant="h5" component="div">
                  {skill.icon}
                </Typography>
                <Typography variant="h6" component="div">
                  {skill.name}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Container>
  );
};

export default Skills;
